import api from 'src/shared/api/axios';
import type { Task } from '../types/task.type';

type ListParams = {
    wbsNodeId?: string;
    milestoneId?: string;
    riskId?: string;

    assigneeUserId?: string;
    createUserId?: string;

    includeInactive?: boolean;
    includeDone?: boolean;
    status?: Task['status'];
    q?: string;
};

export async function apiListTasks(projectId: string, params?: ListParams) {
    const { data } = await api.get(`/projects/${projectId}/tasks`, { params });
    return (data?.data ?? data) as Task[];
}

export async function apiGetTask(projectId: string, taskId: string) {
    const { data } = await api.get(`/projects/${projectId}/tasks/${taskId}`);
    return (data?.data ?? data) as Task;
}

export type CreateTaskInput = {
    title: string;
    description?: string | null;
    progressNote?: string | null;

    wbsNodeId?: string | null;
    milestoneId?: string | null;
    riskId?: string | null;

    assigneeUserId?: string | null; // ✅ ownerUserId 없음, assignee로 통일

    status?: Task['status'];
    urgency: 1 | 2 | 3 | 4 | 5;
    importance: 1 | 2 | 3 | 4 | 5;

    dueDate?: string | null; // 'YYYY-MM-DD'
    isActive?: boolean;
};

export async function apiCreateTask(projectId: string, input: CreateTaskInput) {
    const { data } = await api.post(`/projects/${projectId}/tasks`, input);
    return (data?.data ?? data) as Task;
}

export type UpdateTaskPatch = Partial<CreateTaskInput>;

export async function apiUpdateTask(projectId: string, taskId: string, patch: UpdateTaskPatch) {
    const { data } = await api.patch(`/projects/${projectId}/tasks/${taskId}`, patch);
    return (data?.data ?? data) as Task;
}

export async function apiDeleteTask(projectId: string, taskId: string) {
    const { data } = await api.delete(`/projects/${projectId}/tasks/${taskId}`);
    return data?.data ?? data;
}
